import React from 'react';
import './deep-dives-styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import csr_ca from '../assets/csr-ca.png';
import certificate from '../assets/certificate.png';
import Header from '../components/header';
import GoToTop from '../components/go-to-top';
import Articol from '../components/article';

class ReactToAmplify extends React.Component {
    sendEvent = () => {
        if(window.location.hostname === 'localhost' || window.location.hostname.indexOf('192.168.0') === 0) {
            return;
        }

        if(!sessionStorage.getItem('react-to-amplify')) {
            sessionStorage.setItem('react-to-amplify', true);

            fetch('https://api.ipify.org?format=json')
                .then((ipResp) => ipResp.json().then((ipJson) => {
                    fetch('https://09mclyfv7k.execute-api.eu-central-1.amazonaws.com/prod/log_event', {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({type: 'post-react-to-amplify', name: 'binaryfusion.ro', from: ipJson}),
                    }).then((response) => response.json().then((responseData) => {
                        sessionStorage.setItem('success', responseData.EventId);
                    }));
                })
            );
        }
    }

    componentDidMount() {
        this.sendEvent();
        window.scrollTo(0,0);
    }

    render() {
        const codeStyle = {
            'text-shadow': 'none',
            'border': 'none',
            'box-shadow': 'none,',
            'padding-left': '30px',
        };

        return (
            <div>
                <title>Moving a React website to AWS Amplify</title>
                <Header />

                <GoToTop />
                <div className='page'>
                    <h1 className='title'>React website from Vultr to Amplify</h1>
                    <div className='paragraph'>
                        Updated on 13 May 2025
                    </div>

                    <div className='paragraph'>This shows the process I went through, in my mission to migrate the front ent from a self managed machine on a popular 
                        cloud service provider to an Aplify application on AWS. These are essetially my notes arranged in a more presentable form. The goal is to help 
                        anyone trying to accomplish a symilar process.
                    </div>

                    <h5>Initial state:</h5>
                    <div className='paragraph'>
                        - The source code is kept on Bitbucket<br/>
                        - The original website uses <strong>React</strong> and communicates with <strong>API</strong><br/>
                        - The API runs <strong>Python3.8</strong>, and uses <strong>Flask</strong> for the REST API framework<br/>
                        - The original website, uses SSL certificates, created on <strong>ZeroSSL</strong>, valid for 3 months<br/>
                        - <strong>Nginx</strong> is used to serve static files<br/>
                    </div>

                    <h5>Steps</h5>
                    <div className='paragraph'>
                        1. Import source code in AWS Amplify<br/>
                        2. Establish communication with the API<br/>
                        3. Setup SSL certificates for server communication<br/>
                        4. Update the domain name
                    </div>

                    <h5>1. Import source code in AWS Amplify</h5>
                    <div className='paragraph'>
                        I used the mechanism provided in the AWS Amplify interface.<br/>
                        In <strong>AWS Amplify</strong> service, use <strong>Create new app</strong> button, under <strong>Deploy your app</strong>, select <strong>BitBucket</strong>, and followed the process from there.
                    </div>

                    <div className='issue'>
                        <div className='issue_title'><FontAwesomeIcon className='issue-red' icon={faTriangleExclamation}/> SSL envelope error</div>
                        At "Deploy" stage after importing the BitBucket repository I get an error regarding <span className='error-red'>digital envelope routines::unsupported.</span> 
                    </div>

                    <div className='paragraph'>
                        To fix the this error, I admit I took the easy, hacky way out just to keep things moving. 
                        If you would run in the terminal <inline-code>npm run start</inline-code>, you would receive the same error and you would
                        export an environment variable for a quick fix.
                    </div>
                
                    <div className='code'>
                        export NODE_OPTIONS=--openssl-legacy-provider
                        {/* const a = 2;<br/>
                        <comment>
                        # Creates a private key (rootCA.key) and self-signed root CA (rootCA.crt)<br/>
                        </comment>
                        openssl req -x509 -sha256 -days 1825 openssl req -x509 -sha256 -days 1825 -newkey rsa:2048 -keyout rootCA.key -out rootCA.crt */}
                    </div>

                    <div className='paragraph'>
                        In my case, in Amplify, I had to add this environment variable in the <strong>Amplify app</strong>, at <strong>Hosting</strong>, in the <strong>Environment variables</strong> section
                    </div>
                    
                    
                    <h5>1.1. Routing configuration</h5>
                    <div className='paragraph'>
                        When hosting a React website on various services like AWS Amplify, Netlify or others with routing special configuration must be done for routing to work. 
                        In some cases, eg. Netlify, it is required to create a <strong>_redirects</strong> file containing all necessary configuration. In Amplify, routing configuration is accomplished in the web interface in the Amplify App, Hosting, Rewrites and redirects menu item. 
                    </div>
                    <SyntaxHighlighter  language='json' style={dark} customStyle={codeStyle}>
                    {`[
  {
    "source": "https://binaryfusion.ro",
    "status": "302",
    "target": "https://www.binaryfusion.ro"
  },
  {
    "source": "/<*>",
    "status": "404-200",
    "target": "/index.html"
  },
  {
    "source": "</^[^.]+$|\\.(?!(css|gif|ico|xml|jpg|js|png|txt|svg|woff|ttf|map|json)$)([^.]+$)/>",
    "status": "200",
    "target": "/index.html"
  }
]
`}
                    </SyntaxHighlighter>
                    In the React project I have
                    <SyntaxHighlighter  language='javascript' style={dark} customStyle={codeStyle}>
                    {`import { BrowserRouter, Route, Routes } from 'react-router-dom';

…

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="*" element={<HomePage />} />
                <Route path="/case-studies" element={<CaseStudies />} />
                <Route path="/deep-dives" element={<DeepDives />} />
            </Routes>
        </BrowserRouter>
    )
}
`}
                    </SyntaxHighlighter>


                    <h5>2. Establish communication with the API</h5>
                    <div className='paragraph'>
                        My server was running a Flask web server to provide a REST api for the React front-end.
                        For production run I used <inline-code>gevent.pywsgi</inline-code>.
                        I needed to make the Amplify app to comunicate with my own hosted web server as the original website.
                        In the original case Nginx was configured as a proxy server that redirected calls to the server IP address.
                    </div>

                    <div className='paragraph'>
                        This was the original Nginx config file, located at <inline-code>/etc/nginx/sites-enables/default</inline-code><br/><br/>
                        <SyntaxHighlighter  language='bash' style={dark} customStyle={codeStyle}>
                    {`listen 443 ssl default_server;

listen [::]:443 ssl default_server;

server_name subdomain.binaryfusion.ro;

# SSL certificates
ssl_certificate /root/.acme.sh/subdomain.binaryfusion.ro/fullchain.pem;
ssl_certificate_key /root/.acme.sh/subdomain.binaryfusion.ro/key.pem;

root /var/www/html/app-path;

index index.html index.htm index.nginx-debian.html;

location / {
        # First attempt to serve request as file, then
        # as directory, then fall back to displaying a 404.
        files $uri $uri/ /index.html$is_args$args;
}

location /statistici-api/ {
        proxy_pass http://192.248.XXX.XXXX:5001/statistici-api/;
        proxy_set_header Host $host;
}

location /.well-known/acme-challenge/ {
        alias /var/www/le_root/.well-known/acme-challenge/;
}`}
                        </SyntaxHighlighter>
                    </div>
                As you can see, calls to the REST api, are unencrypted. This will lead to the next issue I faced.

                    <div className='paragraph'>
                        The function nginx covered, should be replaced with <strong>Rewrites</strong> on Amplify app<br/>
                        On the Amplify app, at <strong>Hosting</strong>, select <strong>Rewrites and redirects</strong>, 
                        I added, on top of existing rules the following:
                    </div>

                    <div className='code'>
{`Source                       Target                                                                            Type              
/statistici-api/<*>     http://192.248.XXX.XXX:5001/statistici-api/<*>      200 (Rewrite)
`}
                    </div>

                    <div className='paragraph'></div>
                    <div className='issue'>
                        <div className='issue_title'><FontAwesomeIcon className='issue-red' icon={faTriangleExclamation}/> Unencrypted communication with server</div>
                        This would fail actually because it's not allowed for obvious reasons to add an unencrypted "http" target for a redirect.
                    </div>

                    <div className='paragraph'>
                        On the server, the code looks something like this:
                        <SyntaxHighlighter  language='python' style={dark} customStyle={codeStyle}>
                    {`if __name__== '__main__':
    # Debug/Development
    # app.run(debug=True, host="0.0.0.0", port="5001")

    # Production
    http_server = WSGIServer(('', 5001), app)
    http_server.serve_forever() `}
                        </SyntaxHighlighter>
                        You can see that this server is running without SSL certificates so unencrypted. Secure HTTPS call are not possible.
                    </div>


                    <div className='paraagraph'>
                        I updated the redirect, on the Amplify app, to use a secure HTTP call to be able to save the configuration like this:
                    </div>
                    <div className='code'>
{`Source                       Target                                                                              Type          
/statistici-api/<*>     https://192.248.XXX.XXX:5001/statistici-api/<*>      200 (Rewrite)
`}
                    </div>

                    <div className='paragraph'>
                        You can check if communication is now possible with the server even though a response could not be provided by looking for an error log on the server. 
                        In my case to be able to see the logs directly, I stopped the server and started again  with <inline-code>python3.8 server.py</inline-code>
                    </div>

                    <div className='paragraph'>
                        I checked the unencrypted connection is still possible with
                    </div>
                    <div className='code'>
                        curl http://192.248.XXX.XXX:5001/statistici-api/some-endpoint/
                    </div>
                    <div className='paragraph'>
                        Then, by refreshing the webiste hosted on Amplify, I should be able to receive an error on the server, since it will not be capable of understanding the request due to the encryption.
                    </div>

                    <div className='side-story'>
                        <h2>Side story: ufw is blocking calls</h2>

                        <div className='paragraph'>
                            On the first try, the <inline-code>curl</inline-code> was failing due to timeout error. The problem was due to <inline-code>ufw</inline-code> configuration on the server.
                            For security reasons, I added a rule to ufw to only accept incoming calls from the IP of the machine hosting the front end.<br/>
                            <div className='code'>[ 8] 5001/tcp                   ALLOW IN    209.250.236.95</div>
                            For this reason, not only calls from Amplify app but also from <inline-code>curl</inline-code> were failing. To solve this I changed the rule to accept incoming connections from any IP on the configured server port:
                            <div className='code'>ufw allow in to any port 5001</div>
                        </div>
                    </div>

                    <div className='paragraph'>
                        We now reached step 3, where we must run the server with SSL certificates so that the Aplify redirect would return a correct response.
                    </div>

                    <h5>3. Setup SSL certificates for server communication</h5>
                    <div className='paragraph'>
                        My first try was to use <inline-code>openssl</inline-code> to generate a self-signed 
                        root CA certificate and the pair of private key and the cerficate. Although I failed 
                        on this attempt, I will describe the steps here in the hope that it will be usefull for 
                        someone and also hoping that I will come back and finish this step. The reason I intented to use openssl was not only because it's free but also 
                        because we can set the availability period as much as desired.
                    </div>

                    <img alt='CSR and CA generator' className='img-row' src={csr_ca} />

                    <h5>3.1. OpenSSL without rootCA</h5>
                    <div className='paragraph'>
                        First try was to simply generate a pair of certificate and private key using <inline-code>openssl</inline-code> and use them on the server to enable secure communication.<br/>
                        The command used to generate the pair is:
                        <div className='space10' />
                        <div className='code' type='full-line'>
                            {`openssl req -new -newkey rsa:2048 -days 365 -nodes -x509 -keyout server.key -out server.crt        `}
                        </div>
                        <inline-code>-x509</inline-code> tells OpenSSL to create a self-signed certificate instead of a certificate signing request (CSR).<br/>
                        Then I simply copied <inline-code>server.key</inline-code> and <inline-code>server.crt</inline-code> and used them to start the server with:
                    </div>

                    <SyntaxHighlighter  language='python' style={dark} customStyle={codeStyle}>
                    {`from gevent.pywsgi import WSGIServer
# ...
if __name__== '__main__':
    http_server = WSGIServer(('', 5001), app, keyfile='server.key', certfile='server.crt')
    http_server.serve_forever() `}
                    </SyntaxHighlighter>

                    <div className='paragraph'>
                        Then I tested with <inline-code>curl</inline-code> and got an UNKNOWN_CA error:
                    </div>

                    <div className='issue'>
                        <div className='issue_title'><FontAwesomeIcon className='issue-red' icon={faTriangleExclamation}/> Missing root CA</div>
                        On the server, I could see the next error, which made sens since the issuing CA could not be considered <strong>trusted</strong>.
                        <div className='space10' />
                        <div className='code'>
                        {`ssl.SSLError: [SSL: TLSV1_ALERT_UNKNOWN_CA] tlsv1 alert unknown ca (_ssl.c:1131)<br/>
    2024-06-18T19:00:27Z <Greenlet at 0x7f07f683f9d0: _handle_and_close_when_done(<bound method StreamServer.wrap_socket_and_handle , <bound method StreamServer.do_close of <WSGIServer, (<gevent._socket3.socket [closed] at 0x7f07f60ad52)> failed with SSLError`}
                        </div>

                    </div>
                
                    <img alt='CSR and CA generator' className='img-row' src={certificate} />

                    <h5>3.2. OpenSSL with rootCA</h5>

                    <div className='paragraph'>
                        As a reference this process follows these basic steps: <br/>
                        - Create a Self-Signed Root CA<br/>
                        - Creating a Certificate Signing Request and Sign Our CSR With Root CA<br/>
                        - Creating a Self-Signed Certificate<br/>
                        - Install the root CA certificate on Amplify<br/>
                    </div>

                    <div className='paragraph'>
                        It is possible to create the rootCA for a specific IP but I made the choice to do it for a domain or more precisely for a subdomain of my own domain.
                        So the first step to be able to continue was to assign a domain name for my server IP. You can do this by adding a <inline-code>A record</inline-code> on your Domain Name provider website, in my case this was IONOS. My entry looks something like this:
                    </div>

                    <div className='code'>
{`Record Type      Host                                            Target                         TTL             
A                           subdomain.domain.com      192.248.XXX.XXX        3600
`}
</div>

                    <div className='paragraph'>
                        This will take few minutes to propagate but after you will get some kind of notification that the records were added succesfully, you can test the call to your API, at this point running only without SSL with a <inline-code>curl</inline-code> command symilar with the one below and look for any kind of reaction on the server.
                    </div>

                    <div className='code'>
                        {`curl http://subdomain.domain.com:5001/statistici-api/some-endpoint/           `}
                    </div>

                    <div className='paragraph'>
                        Now I can start creating the certificates with my new domain name for the server. For the next section I inspired myself from <a target="blank" href='https://www.baeldung.com/openssl-self-signed-cert'><strong>this post</strong></a>.
                        To create the rootCA key and crt file I used the command
                    </div>

                    <div className='code'>
                        {`openssl req -x509 -sha256 -days 1825 -newkey rsa:2048 -keyout rootCA.key -out rootCA.crt            `}
                    </div>
                    <div className='paragraph'>
                        As I mentioned above, you can see that you can choose the value for <inline-code>-days</inline-code> as you please. I find this usefull. Again<br/>
                        - <inline-code>-x509</inline-code> tells OpenSSL to create a self-signed certificate instead of a certificate signing request (CSR).<br/>
                        - I did use a passphrase since you need to enter it only when you generate a new certificate from this root certificate<br/>
                        - for <inline-code>FQDN</inline-code> I used only the domain name, without the subdomain<br/>
                        - This command generated <inline-code>rootCA.crt rootCA.key</inline-code>
                    </div>
                    <div className='paragraph'>
                        Next I generated the CSR, Certificate Signing Request
                    </div>

                    <div className='code'>
                        {`openssl req -newkey rsa:2048 -nodes -keyout server.key -out server.csr           `}
                    </div>
                    <div className='paragraph'>
                        - for <inline-code>FQDN</inline-code> I used only the domain name without subdomain, as above<br/>
                        - This command generated <inline-code>server.key server.csr</inline-code>
                    </div>

                    <div className='paragraph'>
                        Next I generated the CSR, Certificate Signing Request
                    </div>
                    <div className='code'>
{`authorityKeyIdentifier=keyid,issuer
basicConstraints=CA:FALSE
subjectAltName = @alt_names
[alt_names]
DNS.1 = binaryfusion.ro`}
                    </div>

                    <div className='paragraph'>
                        To sign the CSR with the root certificate and its private key I used this command:
                    </div>
                    <div className='code'>
                        {`openssl x509 -req -CA rootCA.crt -CAkey rootCA.key -in server.csr -out server.crt -days 365 -CAcreateserial -extfile domain.ext        `}
                    </div>
                    <div className='paragraph'>
                        - This generated <inline-code>server.crt</inline-code>
                    </div>

                    <div className='paragraph'>
                        I copied the generated certificates in the same location with the server source code. Now I can start the server after adding the root certificate at parameter <inline-code>ca_certs</inline-code>
                    </div>

                    <SyntaxHighlighter  language='python' style={dark} customStyle={codeStyle}>
                    {`from gevent.pywsgi import WSGIServer
# ...
if __name__== '__main__':
    http_server = WSGIServer(('', 5001), app, ca_certs='rootCA.crt' keyfile='server.key', certfile='server.crt')
    http_server.serve_forever() `}
                    </SyntaxHighlighter>
                    <div className='space30' />

                    <div className='issue'>
                        <div className='issue_title'><FontAwesomeIcon className='issue-red' icon={faTriangleExclamation}/> Certs locations</div>
                            When starting the server, and testing it using <inline-code>curl</inline-code>, I got an error on the code <inline-code>self._context.load_verify_locations(ca_certs)</inline-code>. 
                            For some reason I stopped at this point. I learned later that I was receiving this error because the path values given to <inline-code>ca_certs, keyfile, certfile</inline-code> should 
                            consider the location from where the server is started
                        <div className='space10' />
                    </div>
                    <div className='space30' />

                    <div className='side-story'>
                        <h2>Side story: starting the server with <inline-code>crontab</inline-code></h2>

                        <div className='paragraph'>
                            My setup for making sure the server was always runnig was rather crude but simple. I added a crontab enty to run every half hour a starter
                            bash script that was checking if my process was running. In case was running, nothing would be done other then adding a log line to show
                            that a check was done. But in the other case, it was running as I would normally do <inline-code>python3.8 server.py</inline-code> with some 
                            logging added.<br/>
                            <div className='space10' />
                            The <inline-code>crontab</inline-code> entry looks like this:
                            <div className='space10' />
                            <div className='code' type="one-line">{'*/30 * * * * /bin/bash /root/statistici/server_starter.sh >> /var/log/server_starter.logs 2>&1       '}</div>
                        </div>

                        <div className='paragraph'>
                            The <inline-code>server-starter.sh</inline-code> looks like this:
                            <div className='space10' />
                            <SyntaxHighlighter  language='bash' style={dark} customStyle={codeStyle}>
                                {`now=$(date +"%H:%M %d-%m-%Y")
ps_output=$( ps aux | grep python3.8 )
if [[ $ps_output == *"server.py"* ]]; then
    echo "$now server.py is running. Not doing anything"
else
    echo "$now Serverul is STOPPED. Starting..."
    python3.8 /root/statistici/server.py >> /var/log/server_statistics.logs 2>&1
fi`}
                            </SyntaxHighlighter>
                        </div>
                        
                        <div className='paragraph'>
                            The above issue was caused by the fact that when server was starting by this script, the paths for the certificated were simply wrong.
                            One of the solutions is to provide absolute paths for <inline-code>ca_certs keyfile certfile</inline-code> parameters.
                        </div>
                        <div className='paragraph'>
                            A symptom of this issue was that when I started the server manually, it worked perfectly but when I let the started script do its job
                            as I would normally expect, the issue became visible.
                        </div>

                    {/* Closing side story  */}
                    </div>

                    <div className='paragraph'>
                        Here, the next step would be to add the rootCA to the trusted list of certificates on Amplify.
                        I tried to do it using <strong>AWS Certificate Manager(ACM)</strong> service, under <strong>List certificates </strong>
                        and use <strong>Import</strong> button to add the contents of the private key and the certificate. 
                        I stopped here because of PEM file format error and I will not go deeper on this path, in this post.
                    </div>

                    <h5>3.3. Using ZeroSSL certificates</h5>
                    <div className='paragraph'>
                        My next idea was to create certificates using the service provided by ZeroSSL. Since now I have a domain name pointing to my server IP address I can use a service like <a href='https://help.zerossl.com' target='_blank' rel="noreferrer"><strong>ZeroSSL</strong></a>. This is pretty straight forward. 
                        The service supplies the user with 3 file: <inline-code>ca_bundle.crt private.key certificate.crt</inline-code>. I used them exactly as it is to start the server as described before:
                    </div>

                    <div className='code'>
                    {` http_server = WSGIServer(('', 5001), app, ca_certs='ca_bundle.crt' keyfile='private.key', certfile='certificate.crt') `}
                    </div>

                    <div className='paragraph'>
                        The important thing to remember here is to provide absolute paths to the certificate files.
                        Now the <inline-code>curl</inline-code> call worked succesfully and also when testing the actual website hosted on Amplify. 
                    </div>

                    <div className='code'>
                        {`curl https://subdomain.domain:5001/api-name/end-point-name/   `}
                    </div>

                    <div className='paragraph'>
                        You should understand that at this point I was using for the new Amplify website the default domain name provided by the framework.
                        So now the only step remaining to consider this process complete was to use the original domain name with the new Amplify hosted page.
                    </div>


                    <h5>4. Update domain name</h5>

                    <div className='paragraph'>
                        The last missing piece is to use the same domain name for the new hosting location of my website as before. 
                        This means 2 things: delete the <inline-code>A Record</inline-code> that points to the existing IP location and add the desired custom domain
                        to Amplify app.
                    </div>

                    <div className='paragraph'>
                        I started the cleaning process from old records. This is done from on your Domain Name provider website, as I mentioned by deleting 
                        any record that will be replaced in AWS platform.
                    </div>

                    <div className='paragraph'>
                        On <strong>AWS</strong>, at the desired <strong>Amplify app</strong>, under <strong>Hosting</strong>
                        select <strong>Custom domains</strong> and use <strong>Add domain</strong> button. All was rather self explanatory. The only thing
                        to mention is that I used the redirect from <inline-code>www.</inline-code> to main domain name. The other information worth mentioning is that
                        I used AWS managed HTTPS certificate.
                    </div>

                    <div className='paragraph'>
                        The important setup that will make this spep work is to add the new necessary DNS records. To see them, use the <strong>Actions</strong> dropdown button
                        and <strong>View DNS records</strong> button, inside <strong>Custom domains</strong> configuration interface. You can find here a <inline-code>CNAME</inline-code>
                        verification record and 2 <inline-code>CNAME</inline-code> subdomain records for cloudfront.net
                    </div>

                    <div className='paragraph'>
                        All these steps will require some time to take effect. Personally to notice when the switch is done from the first default domanin name provided by AWS to 
                        my own custom domain, I checked the Issuer of the certificate that is displayed by the browser.
                    </div>
                    
                    <div className='space10' />
                    
                    <div className='issue'>
                        <div className='issue_title'><FontAwesomeIcon className='issue-red' icon={faTriangleExclamation}/> Adding subdomains records to your DNS provider...</div>
                        One issue that could show up at this stage is getting stuck in the process of adding the custom domain. In my case I couldn’t pass the step called "Adding subdomains records to your DNS provider...". 
                        Eventually the delay was so extensive that the Amplify app was cancelling adding my domain with the error:
                        
                        <div className='error-red'>One or more aliases specified for the distribution includes an incorrectly configured DNS record that points to another CloudFront distribution. 
                        You must update the DNS record to correct the problem.</div><br/>
                        This error is connected to another AWS Service named AWS Route 53. To be able to use my custom domain that I acquired from a separate registrar, it is necessary 
                        to create a hosted zone inside Route 53 with your owned domain name. When adding a custom domain to your AWS Amplify app, a few records are added to this Hosted Zone 
                        to route traffic from your domain name or a subdomain name to a cloudfront address. The issue above is related to the fact that if a previous record already exists 
                        with the same name, it could not be changed to the updated address. This in turn can be related to the inappropriate role permissions or even a missing role.
                        <div className='space10' />
                    </div>

                    <h5>Final thoughts</h5>
                    <div className='paragraph'>
                        Once this is complete I considered the transfer complete and declared myself satisfied. I intent to add more details and corrections the this post. I hope you
                        find something usefull in it and if you can provide me with any feedback feel free to send an email. Will be much appreciated.
                    </div>


                    <div className='articles mt-5'>
                        <Articol title='GoLang Web app on AWS (Part 1) - ECR and Lambda' to={'/dp-golang-webapp-ecr'} />
                        <Articol title='GoLang Web app on AWS (Part 2) - Front-end and CORS' to={'/dp-golang-webapp-cors'} />
                    </div>

                    <div className='mb-10'></div>

                {/* Closing page  */}
                </div>

            {/* Closing first dev  */}
            </div>
        )
    }
}

export default ReactToAmplify;